import React from "react";
export const TabContext = React.createContext({
  tabs: [],
  addRemoveTabs: () => [],
});
const AppContext = React.createContext({
  app: { sidebarOpen: false },
  setApp: () => {},
});
export default AppContext;
